export interface FileInputOptions {
  multiple?: boolean
  accept?: string
  onFilesSelected?: (files: FileList) => void
}

export const createAndTriggerFileInput = (options: FileInputOptions = {}): void => {
  const { multiple = true, accept = 'image/*', onFilesSelected } = options

  const fileInput = document.createElement('input')
  fileInput.type = 'file'
  fileInput.multiple = multiple
  fileInput.accept = accept
  fileInput.style.display = 'none'

  let cleanupTimer: number | undefined
  let isRemoved = false
  const cleanup = () => {
    if (isRemoved) return

    isRemoved = true
    if (cleanupTimer !== undefined) window.clearTimeout(cleanupTimer)
    window.removeEventListener('focus', handleWindowFocus)
    document.body.removeChild(fileInput)
  }
  const handleWindowFocus = () => {
    // The file dialog closes before the browser dispatches change. Waiting one
    // tick covers cancellation without removing the input too early in Safari.
    cleanupTimer = window.setTimeout(cleanup, 0)
  }

  fileInput.onchange = (event) => {
    const files = (event.target as HTMLInputElement).files
    if (files && files.length > 0) {
      onFilesSelected?.(files)
    }
    cleanup()
  }

  document.body.appendChild(fileInput)
  window.addEventListener('focus', handleWindowFocus)
  fileInput.click()
}

export const createAndTriggerPluploadFileInput = (options: Omit<FileInputOptions, 'onFilesSelected'> = {}): void => {
  createAndTriggerFileInput({
    ...options,
    onFilesSelected: (files) => {
      if ((window as any).pluploadInstance) {
        Array.from(files).forEach((file) => {
          ;(window as any).pluploadInstance.addFile(file)
        })
      }
    },
  })
}
